import {Component, Input, OnInit} from '@angular/core';
import {ImpressaoService} from '../../services/impressao.service';

@Component({
  selector: 'app-grid-transacoes-caixa',
  templateUrl: './grid-transacoes-caixa.component.html',
  styleUrls: ['./grid-transacoes-caixa.component.scss']
})
export class GridTransacoesCaixaComponent implements OnInit {
  @Input()
  caixa: any = {};

  @Input()
  resumo: any = {};

  @Input()
  editavel = false;

  agora = new Date();
  imprimindoTransacoes = false;


  constructor(private impressaoService: ImpressaoService) { }

  ngOnInit(): void {
  }

  getTotal(tipo: string) {
    return (this.caixa.transacoes || []).map((t: any) => t.tipo === tipo ? t.valor : 0).reduce((a: any, b: any) => a + b, 0)
  }

  excluirTransacao(rowIndex: any) {
    //implementar
  }

  async imprimirTransacoes() {
    if(this.imprimindoTransacoes || !this.caixa?.transacoes?.length)
      return;

    const impressora = this.impressaoService.configImpressao?.impressoras?.[0];

    if(!impressora)
      return this.impressaoService.onErrosImpressao.emit('Nenhuma impressora configurada');

    this.imprimindoTransacoes = true;

    try {
      return await this.impressaoService.imprimaTransacoesCaixa(this.caixa, impressora);
    } finally {
      this.imprimindoTransacoes = false;
    }
  }


}
